export default __webpack_public_path__ + "static/media/miscellaneous26.6f3f00fb.png";